import _ from 'lodash';
import {useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {wardsList} from '../store/reducers/ward';
import {trudWardsDict} from '../store/reducers/dicts';
import {useLocation} from 'react-router-dom';

export default function usePatientLocation(patient) {
    const wardList = useSelector(wardsList);
    const trudWardList = useSelector(trudWardsDict);

    const match = useLocation();
    const stableMatch = useMemo(() => match, [match.pathname]);

    const [patientLocation, setPatientLocation] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (patient) {
            const {wardId} = patient;

            setLoading(true);
            let findWard = _.find(wardList, ward => ward.wardsId.includes(wardId));
            const trud = _.find(trudWardList, {wardCode: wardId});
            setPatientLocation({
                ...findWard,
                trudDescription: trud?.wardName || 'UNKNOWN',
                wardType: checkWardType(findWard),
            });
            setLoading(false);
        } else {
            setPatientLocation(null);
            setLoading(false);
        }
    }, [trudWardList, wardList, stableMatch, patient]);

    const checkWardType = useMemo(() => (wardMap) => {
        if (stableMatch?.pathname?.toLowerCase() === '/ward/ed') {
            return 'ED';
        }
        if (wardMap) {
            if (wardMap.wardsId?.includes('ED')) {
                return 'ED';
            }
            return 'IP';
        }
        return 'UNKNOWN';
    }, [stableMatch]);

    return [patientLocation, loading];
}